import { twMerge } from "tailwind-merge";

export const getBasicInputClassNames = ({
    error = false,
    isDirty = false,
    disabled = false,
}: {
    error: boolean;
    isDirty: boolean;
    disabled: boolean;
}) =>
    twMerge(
        "w-full truncate flex items-center h-6 xl:h-[30px] shrink-0 px-1 xl:px-2 font-semibold outline-none",
        "text-[13px] xl:text-base",
        error ? "border-red-error text-red-error" : "border-black text-black",
        isDirty ? "bg-gray-dark" : "bg-gray-light",
        !disabled && "border-b"
    );
